// @ts-nocheck
import * as $ from 'jquery';
import { TransitConfiguration } from './TransitConfiguration';
import { NotificationType } from 'Common/NotificationManager';
import Mediator from 'Common/Mediator';
import { TransitStatusEnum } from './Models/TransitStatusEnum';
import { Request } from './Models/Request';

export class TransitApplication {
    private currentContainer: JQuery;
    private configuration: TransitConfiguration;
    private transitTable: JQuery;

    constructor(private container: JQuery) {
        this.currentContainer = container;
        this.configuration = new TransitConfiguration(container);
        this.transitTable = container.find('.results-table');
        this.initialize();
    }

    public clickConfirmRequest(evt: JQueryEventObject){
        this.sendRequest(evt, TransitStatusEnum.EmployeeSuccessfulTransitioned);
    }

    public clickCancelRequest(evt: JQueryEventObject){
        this.sendRequest(evt, TransitStatusEnum.NewOrganizationCancelledTransition);
    }

    public clickDeclineRequest(evt: JQueryEventObject) {
        this.sendRequest(evt, TransitStatusEnum.OldOrganizationDeclinedTransition);
    }

    private sendRequest(evt: JQueryEventObject, transitStatusEnum: TransitStatusEnum){
        let target = $(evt.currentTarget);
        let tr = target.closest('tr');
        let transitId = tr.data('transitId');
        var request = new Request(transitId, transitStatusEnum);

        $.ajax({
            url: this.configuration.changeUrl,
            data: request,
            type: 'POST',
            dataType: 'json',
            success: function (data) {
                Mediator.instance.publish('notification:show', "Successful", NotificationType.Success, true);
                tr.fadeOut(1000);
            },
            error: function (data) {
                const json = data.responseJSON;
                let message = json.Message;
                if (!message) {
                    message = `${json.status} ${json.title}`;
                }
                Mediator.instance.publish('notification:show', message, NotificationType.Error, true);
            }
        });
    }

    private initialize() {
        this.transitTable.add(this.transitTable)
        .on('click', '.confirm', (event) => this.clickConfirmRequest(event));

        this.transitTable.add(this.transitTable)
        .on('click', '.decline', (event) => this.clickDeclineRequest(event));

        this.transitTable.add(this.transitTable)
        .on('click', '.cancel', (event) => this.clickCancelRequest(event));
    }
}
